import React from "react";
import ForRentCostumesDetails from "./for-rent-costumes-details/for-rent-costumes-details";

const ForRentCostumesDetailsContainer = () => {
    return (
        <>
            <div style={{ padding: 20 }}>
                <ForRentCostumesDetails/>
            </div>
        </>
    )
};

export default ForRentCostumesDetailsContainer;